// extracted by mini-css-extract-plugin
export default {"body":"FUTIH","reminder":"VIFRF","personalList":"psEY9","personalItem":"JyEEI"};